import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import AppearanceControls from './AppearanceControls';

export default function AppearanceDialog({ open, file, onClose, onChange, onReset }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{file ? `${file.name} Appearance` : 'Appearance'}</DialogTitle>
      <DialogContent sx={{ pb: 3 }}>
        {file ? (
          <AppearanceControls
            appearance={file.appearance}
            onChange={onChange}
            onReset={onReset}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
